<template>
  <div class="contragents ms-container">
    <div class="contragents__header filters-bar">
      <contragents-filter />
      <router-link
        v-if="getContractModulePerms('contragents', 'create')"
        :to="`/app/contragents/edit?contract_id=${id}`"
      >
        <i-button type="success">Создать подрядчика</i-button>
      </router-link>
    </div>
    <inline-loader :loading="loading" v-if="loading && !nodata" />
    <div class="ms-nodata ms-text" v-else-if="!loading && nodata">
      Не удалось загрузить список подрядчиков. Повторите, пожалуйста, попытку
      позже
    </div>
    <contragents-list
      :contragents="contragents"
      v-else-if="contragents.length"
    />
    <div v-else class="ms-nodata ms-text">
      Подрядчики отсутствуют
    </div>
  </div>
</template>

<script>
import ContragentsList from '@/components/contragents/contragents-list'
import ContragentsFilter from '@/components/filters/contragents'
import InlineLoader from '@/components/loaders/inline-loader'
import { getContragentsUrl } from '@/config/filters'

export default {
  components: {
    ContragentsList,
    ContragentsFilter,
    InlineLoader
  },
  data () {
    return {
      loading: false,
      nodata: false,
      contragents: [],
      id: this.$route.params.id
    }
  },
  watch: {
    '$store.state.filters.contragents': {
      handler: function () {
        this.getContragents(true)
      },
      deep: true
    }
  },
  methods: {
    async getContragents (noloading) {
      try {
        if (!noloading) this.loading = true
        const url = getContragentsUrl(
          `page/contragent?contract_id=${this.id}`,
          this.$store.state.filters.contragents
        )
        this.contragents = await this.$store.dispatch('GET_REQUEST', { url })
        this.loading = false
      } catch (error) {
        console.log(error)
        this.loading = false
        this.nodata = true
      }
    }
  },
  created () {
    this.getContragents()
  }
}
</script>

<style lang="less"></style>
